import { JournRepositoriesProvider } from '_/features/journ/ui/contexts/journ-repositories-provider'
import { createFileRoute, Outlet } from '@tanstack/react-router'

const JournLayout = () => (
	<JournRepositoriesProvider>
		<Outlet />
	</JournRepositoriesProvider>
)

export const Route = createFileRoute('/_authenticated/journ')({
	component: JournLayout,
})
